import { AbstractPopUp } from './AbstractPopUp';
import Text = PIXI.Text;
import Point = PIXI.Point;
import Sprite = PIXI.Sprite;
import { TextStyles } from '../utils/TextStyles';
import { createSprite, translate } from '../utils/GameEngine';
import { SceneManager } from '../core/managers/SceneManager';
import { clearAnimations } from '../utils/Animations';

export class PreAdPopup extends AbstractPopUp {
    private timerID: any;
    private loadingText: PIXI.Text;
    private counter: number = 3;
    private loadingIcon: PIXI.Sprite;
    private underlay: Sprite;

    protected drawLayout(params?: any): void {
        super.drawLayout(params);

        this.loadingIcon = createSprite('ad_loading_donut@2x', this);
        this.loadingIcon.anchor.set(0.5, 0.5);
        this.loadingIcon.position.set(0, SceneManager.gameHeight / 4);

        this.loadingText = new Text(translate('Loading ad') + '...', TextStyles.counterText);
        this.loadingText.anchor.set(0.5, 0.5);
        this.loadingText.position.set(0, this.loadingIcon.y - this.loadingIcon.height);
        this.addChild(this.loadingText);

        const text1: string =
            FBInstant.player.getName().toUpperCase() + ', ' + translate('by watching an ad,\nyou support us in creating more free content', true) + '!';
        const text2: string =
            translate('We would like to say:\nThank you', true) + ', ' + FBInstant.player.getName().toUpperCase() + '!';
        let tyText: string;
        if (Math.random() < 0.5) {
            tyText = text1;
        } else {
            tyText = text2;
        }
        const thankYouText: PIXI.Text = new PIXI.Text(tyText, TextStyles.winPopupLabel);
        this.addChild(thankYouText);
        thankYouText.anchor.set(0.5, 0.5);
        thankYouText.position.set(this.loadingIcon.x, this.loadingIcon.y + 150);
    }

    protected setPosition(): void {
        this.pivot = new Point(this.width / 2, this.height / 2);
        this.position.set(SceneManager.gameWidth / 2 + this.width / 2, SceneManager.gameHeight / 2);
    }

    public show(keepQueue: boolean = false): void {
        this.counter = 3;
        this.timerID = setInterval(this.stepTimer.bind(this), 1000);
        if (!this.underlay) {
            this.underlay = createSprite('overlay_gradient');
        }

        this.underlay.width = SceneManager.gameWidth;
        this.underlay.height = SceneManager.gameHeight;
        this.underlay.alpha = 0.8;
        this.underlay.interactive = true;
        SceneManager.getInstance().stage.addChild(this.underlay);
        SceneManager.getInstance().stage.addChild(this);
        this.loadingIcon.rotation = 0;
        TweenLite.to(this.loadingIcon, 180, {rotation: 300});
        this.setPosition();
    }

    private stepTimer(): void {
        if (this.counter > 1) {
            this.counter--;
        } else {
            clearInterval(this.timerID);
        }
    }

    public hide(quick: boolean = false): void {
        clearInterval(this.timerID);
        clearAnimations(this.loadingIcon);
        SceneManager.getInstance().stage.removeChild(this);
        SceneManager.getInstance().stage.removeChild(this.underlay);
    }
}